<!--====== footer PART START ======-->
<footer class="footer-area footer-area-2 bg_cover" style="background-image: url(assets/images/footer-bg.jpg);">
    <div class="footer-overlay">
        <div class="container position-relative">
            <div class="row">
                <div class="col-lg-4 col-md-7">
                    <div class="widget-item-1">
                        <img class="c-imageFooter" src="assets/images/imagesAssets/logoisnfooter.png" alt="">
                        <p class="colorIsn">L'ISN POLYSCIENCE est fondé par l'initiative de l'ancien Directeur des Etudes de l'Institut Panafricain de Formation avec l'implication de professeurs attitrés ayant déja offert des prestations de haute qualité à l'université Cheikh
                            Anta DIOP et dans les autres établissements privés de formation en santé.</p>
                        <!-- <p>One thing that hasn’t changed is that we’re a small team — with most of us not working</p> -->
                    </div>
                    <!-- widget item 1 -->
                </div>
                <div class="col-lg-3 offset-lg-1 col-md-5">
                    <div class="widget-item-2 mt-30">
                        <h4 class="title">Pages</h4>
                        <div class="footer-list">
                            <ul>
                                <li><a routerLink="/accueil" class="c-menuFooter"><i class="fal fa-angle-right"></i> Accueil</a></li>
                                <li><a routerLink="/universite" class="c-menuFooter"><i class="fal fa-angle-right"></i> Université</a></li>
                                <li><a routerLink="/sante" class="c-menuFooter"><i class="fal fa-angle-right"></i> Formations</a></li>
                                <li><a routerLink="/admission" class="c-menuFooter"><i class="fal fa-angle-right"></i> Admission</a></li>
                                <li><a routerLink="/contact-isn" class="c-menuFooter"><i class="fal fa-angle-right"></i> Contact</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="widget-item-2 widget-item-3 mt-30">
                        <h4 class="title">Horaires</h4>
                        <ul>
                            <li><span class="c-horaire">8:00 - 17:00, du Lundi au Samedi</span></li>
                            <!-- <li>Saturday: 7:00 - 12:00</li>
                            <li>Sunday and holidays: 8:00 - 10:00</li> -->
                        </ul>
                        <p><span>Notre équipe est disponible 24/7 pour répondre à toutes vos questions.</span></p>
                        <!-- <a href="#"><i class="fal fa-angle-right"></i>Discover More</a> -->
                        <a class="main-btn2" routerLink="/contact-isn">Contactez-nous</a>
                    </div>
                    <!-- widget item 3 -->
                </div>
            </div>
            <!-- row -->
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-copyright">
                        <!-- <p>Copyright By <span>HORS NORMES</span> - 2021</p> -->
                        <p>© 2022 <span>SENYITTE</span> | Tout droit réservé</p>
                    </div>
                    <!-- footer copyright -->
                </div>
            </div>
            <!-- row -->
            <div class="shape-1"></div>
            <div class="shape-2"></div>
            <div class="shape-3"></div>
        </div>
        <!-- container -->
    </div>
</footer>
<!--====== footer PART ENDS ======-->
<!--====== BACK TO TOP ======-->
<div class="back-to-top back-to-top-2">
    <a href="">
        <i class="fas fa-arrow-up"></i>
    </a>
</div>
<!--====== BACK TO TOP ======-->